import { Pipe, PipeTransform } from '@angular/core';
import { Asset } from 'src/app/modules/standard/v1';
import { PreviewMode, UtilityService } from '../services/utility.service';

// Pure pipe: the cache-busted url is recomputed only when the asset reference changes
// (i.e. on a data reload), not on every change detection cycle.
@Pipe({ name: 'filePreview' })
export class FilePreviewPipe implements PipeTransform {
  constructor(private utilityService: UtilityService) { }

  transform(asset: Asset, mode: PreviewMode = PreviewMode.Thumbnail): string {
    return this.utilityService.getFilePreviewUrl(asset, mode, true);
  }
}
